<div class="width-640">

  <mat-card>

    <div style="width: 100%; text-align: center;">

      <div style="width: 400px; margin: auto;">
        <img style="width: 100%; border-radius: 15px;" src='assets/bjcvs/logo.png'>
      </div>

      <div class="form-wrapper">

        <form [formGroup]="searchForm" id="frm">

          <mat-form-field class="cpf-width"  appearance="outline">
            <input required matInput type="text" [errorStateMatcher]="matcher" [formControl]="searchForm.controls.cpf"
              placeholder="Nº documento" autocomplete="off">
            <mat-error *ngIf="searchForm.controls.cpf.hasError('required')">
              Nº documento é obrigatório
            </mat-error>
          </mat-form-field>

        </form>

        <button style="margin-top: 10px;" mat-raised-button (click)='getUserSubscription()' [disabled]="searchForm.invalid">
          <span>CONSULTAR</span>
        </button>

      </div>

      <h5 style="color:red;">{{_totenService.msgError}}</h5>

      <mat-spinner diameter="20" [ngClass]="{hidden: !_totenService.spinner}"></mat-spinner>
        
    </div>

  </mat-card>

  <div *ngIf="lines.length > 0">

    <mat-card>
      <div id="printable" style="width: 400px; margin: auto; text-align: center;">
        <div>
          <b style='text-transform: uppercase;'>{{ lines[0] }}</b>
        </div>
        <div>
          <i>{{ lines[1] }}</i>
        </div>
        <div style="margin-top: 2px;">
          {{ lines[2] }}
        </div>
        <div>
          {{ lines[3] }}
        </div>
        <div>
          {{ lines[4] }}
        </div>

      </div>
    </mat-card>

    <!--
    <mat-card style="text-align: center;">
      <button style="margin: auto;" mat-raised-button (click)='print()' [disabled]="searchForm.invalid">
        IMPRIMIR
      </button>
    </mat-card>
    -->

  </div>

</div>